<template id="user">
    <div v-loading="loading">
        <top />
        <el-container>
            <el-aside width="300px">
                <el-menu :collapse="collapsed"
                         collapse-transition
                         router
                         :default-active="$route.path"
                         unique-opened>
                    <el-submenu v-for="(menu,index) in allmenu"
                                :key="index"
                                :index="menu.menuname"
                                @click="toZheng(menu.menuname)">
                        <template #title>
                            <i :class="menu.icon"></i>
                            <span>{{ menu.menuname }}</span>
                        </template>
                        <el-menu-item-group v-if="menu.menuname != '政府公开'">
                            <el-menu-item v-for="(chmenu,index) in menu.menus"
                                          :index="chmenu.url"
                                          :key="index"
                                          @click="downAdress(chmenu)">
                                <span>{{ chmenu.menuname }}</span>
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                </el-menu>
            </el-aside>
            <el-container>
                <router-view></router-view>
            </el-container>
        </el-container>
    </div>
</template>
<script>
    import top from "../components/top.vue";
    import { downloadDivs, tuihuiyuanyin } from '@/api/div.js'
    export default {
        components: {
            top,
        },
        data() {
            return {
                collapsed: false,
                loading: false,
                allmenu: [
                    {
                        menuname: "单位管理",
                        icon: "el-icon-message",
                        menus: [
                            {
                                menuname: "单位列表",
                                url: "/user/unitList",
                            },
                            {
                                menuname: "添加单位",
                                url: "/user/unitAdd",
                            },
                            {
                                menuname: "导入单位",
                                url: "/user/unitImport",
                            }, {
                                menuname: "导出单位列表和公开网址",
                                url: "/user/unitList?import",
                            }, {
                                menuname: "导出退回原因",
                                url: "/user/unitList?import",
                            },
                            {
                                menuname: "批量导出公开表",
                                url: "/user/BatchImport",
                            }
                        ],
                    },
                    {
                        menuname: "科室管理",
                        icon: "el-icon-menu",
                        menus: [
                            {
                                menuname: "科室列表",
                                url: "/user/departmentList",
                            },
                            {
                                menuname: "添加科室",
                                url: "/user/departmentAdd",
                            },
                        ],
                    },
                    {
                        menuname: "用户管理",
                        icon: "el-icon-setting",
                        menus: [
                            {
                                menuname: "用户列表",
                                url: "/user/userList",
                            },
                            {
                                menuname: "添加用户",
                                url: "/user/userAdd",
                            },
                        ],
                    },
                    {
                        menuname: "政府公开",
                        icon: "el-icon-setting",
                    }
                ],
            };
        },
        mounted() { },
        created() {
            if (localStorage.getItem('permissions')) {
                this.allmenu = [{
                    menuname: "政府公开",
                    icon: "el-icon-setting",
                }]
            }
        },
        methods: {
            toZheng(val) {
                if (val == '政府公开') {
                    this.$router.push('cms')
                }
            },
            downAdress(menu) {
                if (menu.menuname == '导出单位列表和公开网址') {
                    this.loading = true;
                    downloadDivs()
                        .then((res) => {
                            if (res.type == 'application/json') {
                                this.$alert('服务器繁忙或暂时维护，请稍后再试', '提示', {
                                    confirmButtonText: '确定',
                                    type: 'error',
                                });
                            } else {
                                var blob = new Blob([res], { type: "application/vnd.ms-excel" });
                                var url = URL.createObjectURL(blob);
                                var link = document.createElement("a");
                                link.download = "单位列表和公开网址.xlsx";
                                link.href = url;
                                link.click();
                            }
                            this.loading = false;
                        })
                        .catch((err) => {
                            this.loading = false;
                        });
                } else if (menu.menuname == '导出退回原因') {
                    this.loading = true;
                    tuihuiyuanyin().then((res) => {
                        if (res.type == 'application/json') {
                            this.$alert('服务器繁忙或暂时维护，请稍后再试', '提示', {
                                confirmButtonText: '确定',
                                type: 'error',
                            });
                        } else {
                            var blob = new Blob([res], { type: "application/vnd.ms-excel" });
                            var url = URL.createObjectURL(blob);
                            var link = document.createElement("a");
                            link.download = "单位退回原因.xlsx";
                            link.href = url;
                            link.click();
                        }
                        this.loading = false;
                    })
                        .catch((err) => {
                            this.loading = false;
                        });
                }
            }
        },
    };
</script>
<style scoped>
    #user {
        background-size: 100% 100%;
        display: flex;
        height: 100vh;
        width: 100%;
        position: relative;
    }

    .el-header {
        box-shadow: 0 0 1px;
        background-color: #e5f2ff;
        color: #333;
        height: 100px !important;
        margin-top: 2%;
        padding: 0;
        position: relative;
        display: flex;
    }

    .el-dropdown-menu,
    .el-menu {
        position: relative;
        background-color: #e3f2fd;
    }

    .el-aside {
        /* margin-top: 2%; */
        color: #333;
        overflow: hidden !important;
        background-color: #e1f5fe !important;
        height: 90vh;
        box-shadow: 0 8px 10px -5px rgb(0 0 0 / 20%), 0 16px 24px 2px rgb(0 0 0 / 14%), 0 6px 30px 5px rgb(0 0 0 / 12%);
    }

    /* 展示的列表背景色为白色 */
    .el-submenu .el-menu-item {
        height: 50px;
        line-height: 50px;
        padding: 0 45px;
        min-width: 200px;
        background: #fff;
    }
    /* 鼠标移入背景色 */
    .el-menu-item:hover {
        background-color: #808080 !important;
    }
</style>